import React, { useMemo } from "react";
import Autocomplete from "../Autocomplete";
import { subChannelsSelect } from "../../../models/Channels";

const AutocompleteSubChannels = ({ channel, noShow = [], value, ...rest }) => {
    const options = useMemo(() => {
        return subChannelsSelect
            .filter(c => !channel || c.source.includes(channel))
            .filter(p => !noShow.includes(p.value));
    }, [noShow, channel]);

    const option = useMemo(() => {
        if (!value) return '';
        return subChannelsSelect.find(o => o.value === value);
    }, [value]);

    return (
        <Autocomplete
            fullWidth
            label='Sub canal'
            name='subChannel'
            {...rest}
            value={option}
            isOptionEqualToValue={(option, value) => option.value === value}
            options={options}
            data-testid='subchannel-autocomplete'
        />
    );
}

export default AutocompleteSubChannels;